import React from "react";
import BaseOptions from "./BaseOptions";

export default class ParagraphFieldOptions extends BaseOptions {
  render() {
    return (
      <div>
        {this.renderParagraph()}
        {this.renderVisibilityOption()}
      </div>
    );
  }
}
